import QRCode from "qrcode";

export default function downloadQR(id, callback) {
  generateQRImage(id, function (data, err) {
    if (err) {
      callback(err);
      return;
    }

    const fileName = `qr-${id}.png`;
    const pngData = data.split(',')[1];
    const binaryString = atob(pngData);

    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([byteArray], { type: 'image/png' });
    downloadBlob(blob, fileName);
    callback(null);
  });
}

function generateQRImage(id, callback) {
  const url = `${process.env.REACT_APP_DOMAIN}/?id=${id}`
  QRCode.toDataURL(url, {
      errorCorrectionLevel: "H",
      type: 'image/png'
  }, function (err, data) {
      callback(data, err)
  });
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  a.click();
  URL.revokeObjectURL(url);
  return a;
}